import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TechnicianService } from '../../../services/technician.service';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-edit-leave',
  templateUrl: './add-edit-leave.component.html',
  styleUrls: ['./add-edit-leave.component.scss'],
})
export class AddEditLeaveComponent implements OnInit {
  @Input() users;
  public user: any;
  public startDate: any;
  public endDate: any;
  public busy: any;

  constructor(
    public modal: NgbActiveModal,
    public technicianService: TechnicianService,
    public translate: TranslateService,
  ) {}

  ngOnInit() {}

  save() {
    let tzoffset = new Date().getTimezoneOffset() * 60000;
    const startTime = new Date(
      this.startDate.getFullYear(),
      this.startDate.getMonth(),
      this.startDate.getDate(),
      7,
      0,
      0,
    ).getTime();
    const endTime = new Date(
      this.startDate.getFullYear(),
      this.startDate.getMonth(),
      this.startDate.getDate(),
      22,
      0,
      0,
    ).getTime();

    this.busy = true;
    this.technicianService
      .createCalendarEvent(
        this.user.TechnicianID || this.user.id,
        this.translate.instant('bikeshop.users.leave'),
        moment(startTime - tzoffset).toISOString(false),
        moment(endTime - tzoffset).toISOString(false),
        true,
        moment
          .duration(
            moment(moment(this.endDate).add(1, 'days')).diff(
              moment(this.startDate),
            ),
          )
          .asDays(),
        1,
      )
      .subscribe((event) => {
        this.busy = false;
        this.modal.close();
      });
  }
}
